<template>
    <v-row>
        <v-col sm="12">
            <v-card>
                <v-card-title>
                    <!-- <v-icon @click="pushRouteToView('services')" class="mr-4" style="cursor: pointer">
                                  mdi-arrow-left
                              </v-icon> -->
                    <v-btn
                        small
                        @click="pushRouteToView('charges')"
                        class="mr-4 btn-back"
                    >
                        <v-icon> mdi-arrow-left</v-icon>
                        Voltar
                    </v-btn>
                    <v-icon left>mdi-view-list-outline</v-icon>
                    Dados da Cobrança
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        class="btn-del"
                        @click="dialogDeleteCharge = true"
                        v-if="!charge.canceled"
                    >
                        <v-icon left>mdi-cancel</v-icon>
                        Cancelar Cobrança
                    </v-btn>


                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-data-visualization">
                    <v-card style="border-left: solid 10px #3d1159 !important">
                        <v-card-title></v-card-title>

                        <v-card-text class="text-data-visualization">
                            <v-row>
                                <v-col md="3" sm="6" xs="12" :class="comandaColor(charge.statusID)">
                                    <v-icon v-if="charge.statusID == statusWaitingPayment" class="mr-1"
                                            color="purple darken-1">
                                        mdi-cash-clock
                                    </v-icon>
                                    <v-icon v-if="charge.statusID == statusPaid" class="mr-1" color="green darken-1">
                                        mdi-check-circle-outline
                                    </v-icon>
                                    <v-icon v-if="charge.canceled || charge.statusID == statusCanceled" class="mr-1"
                                            color="red darken-1">mdi-close-circle-outline
                                    </v-icon>

                                    <b>Comanda: </b>
                                    {{ charge.comanda }}

                                </v-col>
                                <v-col md="6" sm="6" xs="12">
                                    <b>Cliente: </b>
                                    {{ charge.personName }}
                                </v-col>
                                <v-col md="3" sm="6" xs="12">
                                    <b>Data: </b>
                                    {{ charge.createdAt | formatDate2 }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12" sm="12" xs="12" class="mb-0 pb-0">
                                    Itens
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row v-for="(order, index) in charge.orders"
                                   :key="index + '_order'">
                                <v-col md="12" sm="12" xs="12">
                                    <v-data-table
                                        v-model="selected"
                                        :headers="headers"
                                        :items="order.items"
                                        :options.sync="options"
                                        dense
                                        item-key="id"
                                        class="elevation-1"
                                        hide-default-footer
                                    >
                                        <template v-slot:item.value="{ item }">
                                            {{ item.value | money }}
                                        </template>
                                        <template v-slot:item.discount="{ item }">
                                            {{ item.discount | money }}
                                        </template>
                                        <template v-slot:item.totalValue="{ item }">
                                            {{ item.totalValue | money }}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col md="12" sm="12" xs="12">
                                    Pagamentos
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row v-for="(payment, index) in charge.descPayments"
                                   :key="index + '_payment'">
                                <v-col md="4" sm="6" xs="12">
                                    <b>Categoria:</b>
                                    {{ payment.category }}
                                </v-col>
                                <v-col md="4" sm="6" xs="12">
                                    <b>Conta:</b>
                                    {{ payment.movement }} {{ payment.receipt }}
                                </v-col>
                                <v-col md="4" sm="6" xs="12">
                                    <b>Valor:</b>
                                    {{ payment.value | money }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12" sm="12" xs="12" class="mb-0 pb-0">
                                    Valores da Cobrança
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="4" sm="6" xs="12">
                                    <b>Valor:</b>
                                    {{ charge.value | money }}
                                </v-col>
                                <v-col md="4" sm="6" xs="12">
                                    <b>Desconto:</b>
                                    {{ charge.discount | money }}
                                </v-col>
                                <v-col md="4" sm="6" xs="12">
                                    <b>Valor Total:</b>
                                    {{ charge.totalValue | money }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12" sm="12" xs="12">
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col md="4" sm="6" xs="12">
                                    <b>Status:</b>
                                    <span v-if="charge.statusID == statusWaitingPayment" color="purple darken-1"> Aguardando Pagamento</span>
                                    <span v-if="charge.statusID == statusPaid" color="green darken-1"> Pago </span>
                                    <span v-if="charge.canceled || charge.statusID == statusCanceled"
                                          color="red darken-1"> Cancelado</span>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-alert type="warning" outlined v-show="!charge"
                >Nenhum serviço encontrado
                </v-alert>
                <confirm-dialog
                    :dialog="dialogActiveInactive"
                    :title="`${charge ? 'INATIVAR ' : 'ATIVAR '} ${charge.name}`"
                    body="Tem certeza que deseja realizar essa ação?"
                    @dialog-event="inactiveActive"
                >
                </confirm-dialog>
                <confirm-dialog
                    :dialog="dialogDeleteCharge"
                    :title="`EXCLUIR COBRANÇA`"
                    :body="`Tem certeza que deseja excluir está combrança <strong>${charge.comanda} </strong>?`"
                    @dialog-event="deleteCharge"
                >
                </confirm-dialog>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";
import ConfirmDialog from "@/components/ConfirmDialog";

import {
    CHARGE_ACTIVE,
    CHARGE_DELETE,
    CHARGE_GET,
    CHARGE_INACTIVE,
} from "@/store/actions/charge.type";
import {
    CHARGE_RESET_STATE,
    SET_CHARGE_ACTIVE,
} from "@/store/mutations/charge.type";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

export default {
    name: "charge",
    directives: {mask},
    props: {
        id: {
            default: 0,
            type: Number,
            required: true,
        },
    },

    components: {ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(CHARGE_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            await store.dispatch(CHARGE_RESET_STATE),
            await store.dispatch(CHARGE_GET, to.params.id),
        ]).then(() => {
            next();
        });
    },
    data: () => ({

        statusWaitingPayment: 2,
        statusPaid: 3,
        statusCanceled: 4,
        pagination: {
            sortBy: "name",
        },
        search: "",
        selected: [],
        formIsValid: false,

        dialogActiveInactive: false,
        dialogDeleteCharge: false,
        options: {},
        headers: [
            {text: "", align: "left", value: "canceled", sortable: false},
            {text: "Profissional", align: "left", value: "bmName"},
            {text: "Item", value: "name"},
            {text: "Valor", value: "value"},
            {text: "Quantidade", value: "quantity"},
            {text: "Desconto", value: "discount"},
            {text: "Valor Total", value: "totalValue"},
        ],
    }),
    methods: {
        pushRouteToView() {
            this.$router.back()
            // this.$router.push({name: route});
        },
        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        deleteCharge(status) {
            this.dialogDeleteCharge = false;
            if (!status) {
                return;
            }
            this.$store.commit(CHANGE_PROGRESS, true);
            this.$store
                .dispatch(CHARGE_DELETE)
                .then(() => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    this.$router.push({
                        name: "charges",
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        inactiveActive(status) {
            this.dialogActiveInactive = false;
            if (!status) {
                return;
            }
            let action = this.charge ? CHARGE_INACTIVE : CHARGE_ACTIVE;
            this.$store.commit(CHANGE_PROGRESS, true);

            this.$store
                .dispatch(action, this.charge.id)
                .then(() => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Alterado com sucesso";
                    this.$store.commit(SET_CHARGE_ACTIVE, !this.charge);
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        comandaColor(status) {
            if (status == this.statusWaitingPayment) {
                return "purple--text"
            } else if (status == this.statusPaid) {
                return "green--text"
            } else if (status == this.statusCanceled) {
                return "red--text"
            }
            return ""
        },
    },
    mounted() {
    },
    computed: {
        ...mapGetters(["snackbar", "inProgress", "checkUsers", "charge"]),
    },
    watch: {},
};
</script>
